document.addEventListener('DOMContentLoaded', function() {
  let isLoading = false;
  const loadingElement = document.getElementById('infinite-scroll-loading');

  function fetchNextPage() {
    if (isLoading) return;

    const nextPageLink = document.querySelector('link[rel="next"]');

    if (!nextPageLink) return;

    loadingElement.style.display = 'block';  // Show the loading message
    isLoading = true;
    fetch(nextPageLink.href)
      .then(response => response.text())
      .then(data => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, 'text/html');

        const newProducts = doc.querySelectorAll('.product-grid .grid__item');
        const grid = document.querySelector('.product-grid');

        newProducts.forEach(item => {
          grid.append(item);
        });

        const nextLink = doc.querySelector('link[rel="next"]');
        if (nextLink) {
          document.querySelector('link[rel="next"]').setAttribute('href', nextLink.href);
        } else {
          window.removeEventListener('scroll', onScroll);
        }

        loadingElement.style.display = 'none';  // Hide the loading message
        isLoading = false;
      });
  }

  function onScroll() {
    if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 1500) {
      fetchNextPage();
    }
  }

  window.addEventListener('scroll', onScroll);
});
